import { t } from '@lingui/macro'
import { FormSubmission, FormSubmissionStatus } from '@/core/models/form.model'

export type EthicsStatusColor = 'warning' | 'success'

export const ETHICS_STATUS_COLOR: Partial<Record<FormSubmissionStatus, EthicsStatusColor>> = {
  [FormSubmissionStatus.Submitted]: 'warning',
  [FormSubmissionStatus.Resolved]: 'success',
}

export function getEthicsSubmissionStatusLabel(status: FormSubmissionStatus): string {
  if (status === FormSubmissionStatus.Submitted) return t`Submitted`
  if (status === FormSubmissionStatus.Resolved) return t`Resolved`

  return status
}

export function getEthicsPatientName(submission: FormSubmission): string {
  const userInfo = submission.patient?.userInfo

  if (!userInfo) return '-'

  return `${userInfo.surname} ${userInfo.name}`
}

export function getEthicsSubmissionSummary(submission: FormSubmission): string {
  const firstTextResponse = submission.responses.find((response) => typeof response.value === 'string' && response.value.length > 0)

  if (!firstTextResponse) return '-'

  const value = String(firstTextResponse.value)
  return value.length > 80 ? `${value.substring(0, 80)}...` : value
}

export function getFieldDisplayValue(value: unknown): string {
  if (Array.isArray(value)) return value.join(', ')
  if (typeof value === 'boolean') return value ? t`Yes` : t`No`

  return String(value ?? '-')
}
